import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import {Point, Circle, Line, Polygon, Minus, Clear, Plus, Ruler, Pozicionet, Latvia, Riga, Edit} from '../icons/index';
import GpsFixed from '@material-ui/icons/GpsFixed';
import GpsOff from '@material-ui/icons/GpsOff';
import Tooltip from '../tooltip';


const iconBtt = (theme) => {

  return {
    width: '28px',
    height: '28px',
    margin: '0.5px',
    boxShadow: theme.shadows[2],
    cursor: 'pointer',
    color: '#00264A',
    backgroundColor: "#fff",
    transition: "height .40s ease",
    '&:hover': {
      color: theme.palette.action.hoverText,
      backgroundColor: 'rgb(0, 38, 74)'//theme.palette.action.hover
    }
  };
};

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
 //   color: '#fff'
  },
  input: {
    display: 'none',
  },
  iconBttGroup: iconBtt(theme),
  iconBtt: iconBtt(theme),
  iconBttHidden:{width: '28px',
    height: 0, transition: "all .40s ease"},
  iconBttDisabled: Object.assign(iconBtt(theme), {color:'#9f9f9f',backgroundColor: '#c2c2c2', '&:hover': {}, cursor: 'default'}),
  iconBttActive: Object.assign(iconBtt(theme), {color: theme.palette.action.hoverText, backgroundColor: 'rgb(0, 38, 74)'}),
});

const ButtonGroup = ({ buttons, onClick, classes, activeBttID }) => {

  var key = 0;
  return (<div style={{display: 'flex', flexDirection: 'column' }}>{buttons.map((btt)=>{
    var iconStyleClass = classes.iconBtt;
    let iconTitle = '';

    if (btt.visible == false) {
      iconStyleClass = classes.iconBttHidden;
    }

    if((typeof activeBttID !== 'undefined' && btt.id === activeBttID) || btt.enabled) {
      iconStyleClass = classes.iconBttActive;
    } else if (!btt.active) {
      iconStyleClass = classes.iconBttDisabled;
    }

    if (typeof btt.title !== 'undefined') {
      iconTitle = btt.title;
    }

    //const toggleActive = ['Point','Circle'].some(item => item === activeBttID);

    //console.log('classes :', classes);
    switch (btt.id) {
      case 'GpsFixed':
        return (<Tooltip key={key++} title={iconTitle}><Pozicionet className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'LVA':
        return (<Tooltip key={key++} title={iconTitle}><Latvia className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'RIX':
        return (<Tooltip key={key++} title={iconTitle}><Riga className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'break':
        return (<div key={key++} style={{padding: '2px'}}></div>);
      case 'Point':
        return (<Tooltip key={key++} title={iconTitle}><Point className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'Circle':
        return (<Tooltip key={key++} title={iconTitle}><Circle className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'RulerLine':
        return (<Tooltip key={key++} title={iconTitle}><Line className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'RulerPolygon':
        return (<Tooltip key={key++} title={iconTitle}><Polygon className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'clear':
        return (<Tooltip key={key++} title={iconTitle}><Clear className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'plus':
        return (<Tooltip key={key++} title={iconTitle}><Plus className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'minus':
        return (<Tooltip key={key++} title={iconTitle}><Minus className={iconStyleClass}  onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'GpsOff':
        return (<Tooltip key={key++} title={iconTitle}><GpsOff className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
      case 'DrawToggle':
        return (<Tooltip key={key++} title={iconTitle}><Edit className={iconStyleClass} onClick={onClick.bind(this, btt )} /></Tooltip>);
    }

  /*  return (<Button raised className={classes.button} key = {key++}
        onClick={onClick.bind(this, btt )}        
    >{btt.text}</Button>);*/
  })}</div>);
};

ButtonGroup.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttons: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  activeBttID: PropTypes.string
};

export default withStyles(styles)(ButtonGroup);